import { Injectable } from '@angular/core';
import * as Enums from '../../bayadic-shared-models/enums/Enums';
import { PrimarySettings } from '../../bayadic-shared-models/classes/system/settings/PrimarySettings';
import {StorageManagerProvider} from '../storage-manager/storage-manager';
import {NotificationsManagerProvider} from '../notifications-manager/notifications-manager';
import { BehaviorSubject } from 'rxjs';
import { SETTINGS } from '../../bayadic-shared-models/enums/Enums';

@Injectable()
export class SettingsManagerProvider {
   private theme: BehaviorSubject<String>;
   _primarySettings: PrimarySettings;
   private currentLang: string = "en";
   constructor(
       public storageManager: StorageManagerProvider, 
       public notificationsManager: NotificationsManagerProvider) {
      this.theme = new BehaviorSubject(Enums.THEMES.light);
  }
  setActiveTheme(val){
      this.theme.next(val);
  }
  getActiveTheme(){
      return this.theme.asObservable();
  }
  isRtl(){
      return this.currentLang == "fa";
  }
  get currentLanguage(){
    return this.currentLang;
  }
  setCurrentLang(lang : string){
    this.currentLang = lang;
  }
  async updateNotificationsStatus(notificationStatus: boolean){
      await this.storageManager.set(SETTINGS.notificationEnable, notificationStatus);
      await this.notificationsManager.saveNotificationOnline(notificationStatus);
  }
  getNotificationsStatus(){
      return this.storageManager.get("notificationEnable");
  }
  getAutoNightMode(){
      return this.storageManager.get("autoNightMode");
  }
  getBubbleCopyStatus(){
      return this.storageManager.get("bubbleCopyEnable");
  }
  setBubbleCopyStatus(enable){
      this.storageManager.set("bubbleCopyEnable",enable);
  }
  setAutoNightMode(enable){
      this.storageManager.set("autoNightMode",enable);
  }
  getPrimarySettings() : Promise<PrimarySettings>{ 
    
    return new Promise((resolve,reject)=>{
        if(this._primarySettings != undefined){
            resolve(this._primarySettings);
        }
        else {
            this.storageManager.get("primarySettings").then(result=>{
                // if(result != undefined){
                    this._primarySettings = new PrimarySettings(result);
                    resolve(this._primarySettings);
                // }
            });
        }
    });
  }
  savePrimarySetting() {
    this.storageManager.set("primarySettings",this._primarySettings);
  }

}
